import { render } from "./MotoSaleForm.vue?vue&type=template&id=969535b8&scoped=true"
import script from "./MotoSaleForm.vue?vue&type=script&lang=js"
export * from "./MotoSaleForm.vue?vue&type=script&lang=js"

import "./MotoSaleForm.vue?vue&type=style&index=0&id=969535b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-969535b8"]])

export default __exports__